"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Shift = void 0;
const types_1 = require("@hoepel.app/types");
/** A shift: an activity or period of a day */
class Shift {
    constructor(props) {
        this.props = props;
    }
    static fromProps(props) {
        return new Shift(props);
    }
    static createFromPreset(tenantId, shiftId, day, preset) {
        return Shift.fromProps({
            tenantId,
            id: shiftId,
            dayId: day.id,
            childrenCanAttend: preset.childrenCanAttend,
            crewCanAttend: preset.crewMembersCanAttend,
            description: preset.description,
            location: preset.location,
            endMinutesSinceMidnight: preset.startAndEndTime.start.minutesSinceMidnight,
            startMinutesSinceMidnight: preset.startAndEndTime.end.minutesSinceMidnight,
            presetName: preset.name,
            priceCents: preset.price.totalCents,
        });
    }
    static sorted(shifts) {
        return [...shifts].sort((a, b) => b.start.getTime() - a.start.getTime());
    }
    toProps() {
        return this.props;
    }
    withChildrenCanAttend(childrenCanAttend) {
        return Shift.fromProps({
            ...this.toProps(),
            childrenCanAttend,
        });
    }
    withCrewCanAttend(crewCanAttend) {
        return Shift.fromProps({
            ...this.toProps(),
            crewCanAttend,
        });
    }
    withPrice(price) {
        return Shift.fromProps({
            ...this.toProps(),
            priceCents: price.totalCents,
        });
    }
    withDescription(description) {
        return Shift.fromProps({
            ...this.toProps(),
            description,
        });
    }
    withLocation(location) {
        return Shift.fromProps({
            ...this.toProps(),
            location,
        });
    }
    withStartTime(start) {
        return Shift.fromProps({
            ...this.toProps(),
            startMinutesSinceMidnight: start.minutesSinceMidnight,
        });
    }
    withEndTime(end) {
        return Shift.fromProps({
            ...this.toProps(),
            endMinutesSinceMidnight: end.minutesSinceMidnight,
        });
    }
    get id() {
        return this.props.id;
    }
    get tenantId() {
        return this.props.tenantId;
    }
    get childrenCanAttend() {
        return this.props.childrenCanAttend;
    }
    get crewCanAttend() {
        return this.props.crewCanAttend;
    }
    get description() {
        return this.props.description;
    }
    get location() {
        return this.props.location;
    }
    /** @deprecated Use .date */
    get dayId() {
        return this.props.dayId;
    }
    get date() {
        return types_1.DayDate.fromDayId(this.props.dayId);
    }
    /** @deprecated Use .presetName */
    get kind() {
        return this.props.presetName;
    }
    get presetName() {
        return this.props.presetName;
    }
    get price() {
        return types_1.Price.fromCents(this.props.priceCents);
    }
    get startTime() {
        return types_1.LocalTime.fromMinutesSinceMidnight(this.props.startMinutesSinceMidnight);
    }
    get endTime() {
        return types_1.LocalTime.fromMinutesSinceMidnight(this.props.endMinutesSinceMidnight);
    }
    get start() {
        return this.date.nativeDayWithOffset(this.startTime);
    }
    get end() {
        return this.date.nativeDayWithOffset(this.endTime);
    }
    get startAndEnd() {
        return new types_1.StartAndEndTime({
            start: this.startTime,
            end: this.endTime,
        });
    }
}
exports.Shift = Shift;
//# sourceMappingURL=shift.js.map